var map = {
	"./sb-logo-dark.png": 593,
	"./sb-logo-dark.svg": 594,
	"./sb-logo-dark@2x.png": 595,
	"./sb-logo-light.png": 596,
	"./sb-logo-light.svg": 597,
	"./sb-logo-light@2x.png": 598,
	"./stijn-bessem-clients-chunk.svg": 599,
	"./stijn-bessem-clients-douwe-egberts.svg": 600,
	"./stijn-bessem-clients-hedo.svg": 601,
	"./stijn-bessem-clients-hollandsnieuwe.svg": 602,
	"./stijn-bessem-clients-kpito.svg": 603,
	"./stijn-bessem-clients-pickwick.svg": 604,
	"./stijn-bessem-clients-t-mobile.svg": 605,
	"./stijn-bessem-clients-voxi.svg": 606,
	"./stijn-bessem-logo-de.png": 607,
	"./stijn-bessem-logo-de.svg": 608,
	"./stijn-bessem-logo-de@2x.png": 609,
	"./stijn-bessem-logo-react.png": 610,
	"./stijn-bessem-logo-react.svg": 611,
	"./stijn-bessem-logo-react@2x.png": 612,
	"./stijn-bessem-logo-vodafone.png": 613,
	"./stijn-bessem-logo-vodafone.svg": 614,
	"./stijn-bessem-logo-vodafone@2x.png": 615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 592;